var _implements = require('util/interface')._implements;
var api = require('../../../content/record-content');

var StructuredRecordContent = _implements(api, function StructuredRecordContentImpl(records) {
    var inlined = [];

    for (var k in records) {
        inlined = inlined.concat(records[k]);
    }

    this.get = function(name, index) {
        index = index || 0;

        if (records[name]) {
            return records[name][index];
        }

        return undefined;
    };

    this.records = function(name) {
        if (records[name]) {
            return records[name].concat([]);
        }

        return inlined.concat([]);
    };

    this.forEach = function(iterator) {
        inlined.forEach(iterator);
    };
});

StructuredRecordContent.Record = _implements(api.Record, function StructuredRecordImpl(fields) {
    var inlined = [];

    for (var k in fields) {
        inlined = inlined.concat(fields[k]);
    }

    this.get = function(name, index) {
        index = index || 0;

        if (fields[name]) {
            return fields[name][index];
        }

        return undefined;
    };

    this.fields = function(name) {
        if (fields[name]) {
            return fields[name].concat([]);
        }

        return inlined.concat([]);
    };

    this.forEach = function(iterator) {
        inlined.forEach(iterator);
    };
});

module.exports = StructuredRecordContent;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/content/structured-record-content/record-content.js
// module id = 295
// module chunks = 0